import React from 'react';
import Skeleton from '@mui/material/Skeleton';
import ImageListItem from '@mui/material/ImageListItem';
import ImageListItemBar from '@mui/material/ImageListItemBar';
import moment from 'moment';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import StarIcon from '@mui/icons-material/Star';
import { styled } from '@mui/material/styles';
import { ARTIST_GALLERY_IMG_VARIATION } from '../../../store/reducers/ArtistReducer';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { setArtistMainImage } from '../../../store/actions/ArtistAction';

const StyledIconButton = styled(IconButton)(({ theme }) => ({
  color: 'rgba(255, 255, 255, 0.54)',
  '&:hover': {
    color: 'rgba(255, 255, 255, 0.8)',
  }
}));

const MainStarIcon = styled(StarIcon)({
  color: 'yellow',
});

const GalleryImage = ({ artist, loading, img, onDelete, ...rest }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  
  // Use selector hooks instead of connect
  const isManager = useSelector(state => state.access.manager);
  
  const handleDelete = () => {
    onDelete(img);
  };

  const handleSetAsMainImage = () => {
    if (artist.Image_Drive_Item__ === img.Drive_Item__) return;
    dispatch(setArtistMainImage(artist.Music_Label_Artist__, img.Drive_Item__));
  };

  if (loading || !img) {
    return (
      <ImageListItem {...rest}>
        <Skeleton width={200} height={180}/>
      </ImageListItem>
    );
  }
  
  return (
    <ImageListItem {...rest}>
      <img src={img.Media_Image[ARTIST_GALLERY_IMG_VARIATION]} alt={img.Filename}/>
      <ImageListItemBar
        title={img.Filename}
        subtitle={moment(parseInt(img.Created.unixms)).format('LLL')}
        actionIcon={
          isManager ? (
            <StyledIconButton onClick={handleDelete} size="large">
              <DeleteIcon/>
            </StyledIconButton>
          ) : null
        }
      />
      <ImageListItemBar
        titlePosition='top'
        actionIcon={
          isManager ? (
            <StyledIconButton
              title={t('artist_set_logo')}
              onClick={handleSetAsMainImage}
              size="large"
            >
              {artist.Image_Drive_Item__ !== img.Drive_Item__ ? (
                <StarBorderIcon/>
              ) : (
                <MainStarIcon />
              )}
            </StyledIconButton>
          ) : null
        }
        actionPosition='right'
      />
    </ImageListItem>
  );
};

export default GalleryImage;